import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@tucar/pit-stop';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Collapse } from '@mui/material';
import BoxFaqParagraph from './aux-items/BoxParagraph';
import { azulTucar } from '../../../themes/variants/TucarColors';
import MixFaqParagraph from './aux-items/MixParagraph';
import BulletedListFaq from './aux-items/BulletedList';
import NumeredListFaq from './aux-items/NumeredList';

const AccordeonFAQ = ({ data }) => {
  const [open, setOpen] = useState(false);
  const content = data.subtitle.raw.children;

  return (
    <Box>
      <Box
        style={{
          borderTop: `1px solid #99C9FF`,
          padding: '20px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: open ? '#E3EDF7' : '#FFF',
        }}
        onClick={() => setOpen(!open)}
      >
        <Typography
          style={{
            fontSize: '14px',
            fontWeight: open ? 500 : 400,
            lineHeight: 1.2,
            color: open ? azulTucar : '#5B5D71',
            transition: 'color 0.3s',
          }}
        >
          {data.title}
        </Typography>

        <KeyboardArrowDownIcon
          sx={{
            color: '#8C9FB1',
            fontSize: '20px',
            transform: open ? 'rotate(-180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
            marginLeft: '10px',
          }}
        />
      </Box>
      <Collapse id="rules" in={open} timeout="auto" unmountOnExit>
        <Box
          style={{
            padding: '20px',
            paddingTop: '0px',
            backgroundColor: open ? '#E3EDF7' : '#FFF',
            gap: '10px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {content.map((item, index) => {
            const identifier = `${data.id}-${index}`;
            if (item.type === 'paragraph') {
              if (item.children.length > 1)
                return <MixFaqParagraph key={identifier} data={item.children} ident={identifier} />;
              return (
                <BoxFaqParagraph
                  key={identifier}
                  data={{
                    text: item.children[0].text,
                    bold: item.children[0].bold,
                  }}
                />
              );
            }
            if (item.type === 'bulleted-list') {
              return <BulletedListFaq key={identifier} data={item.children} ident={identifier} />;
            }
            if (item.type === 'numbered-list') {
              return <NumeredListFaq key={identifier} data={item.children} ident={identifier} />;
            }
            return <Box key={identifier} />;
          })}
        </Box>
      </Collapse>
    </Box>
  );
};

AccordeonFAQ.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.shape({
      raw: PropTypes.shape({
        children: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
    id: PropTypes.string,
  }),
};

AccordeonFAQ.defaultProps = {
  data: {
    title: '',
    subtitle: {
      raw: { children: [] },
    },
    id: '',
  },
};

export default AccordeonFAQ;
